import React from "react";
import "./Our_Team.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Our_Team = () => {
  const teamMembers = [
    {
      name: "Rohit Sharma",
      role: "Founder & CEO",
      img: "/assets/images/about_us/our_team/rohit.png",
    },
    {
      name: "Vikram Patel",
      role: "Chief Auto Technician",
      img: "/assets/images/about_us/our_team/vikram.png",
    },
    {
      name: "Sanya Verma",
      role: "Body & Paint Specialist",
      img: "/assets/images/about_us/our_team/sanya.png",
    },
  ];

  return (
    <section className="team_section">
      <div className="container">
        <div className="team_header">
          <Common_Title pageTitle="Our Team" boxText="The Experts Behind The Wheel" />
        </div>

        <div className="team_members">
          {teamMembers.map((member, idx) => (
            <div key={idx} className="team_card">
              <div className="img_hold">
                <img src={member.img} alt={member.name} className="team_image" />

                
                <div className="team_info">
                  <h3 className="team_name">{member.name}</h3>
                  <p className="team_role">{member.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Our_Team;